module.exports = __webpack_public_path__ + "media/images/logo-21f8cf11c370e1b96e9decf7ef22fa39.gif";